export default __webpack_public_path__ + "static/media/confirm-company.210defc6.svg";